'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (ResponsibleGamingMenuTabs) {
    ResponsibleGamingMenuTabs["LIMITS"] = "LIMITS";
    ResponsibleGamingMenuTabs["REALITY_CHECK"] = "REALITY_CHECK";
    ResponsibleGamingMenuTabs["TIME_OUT"] = "TIME_OUT";
    ResponsibleGamingMenuTabs["SELF_EXCLUDE"] = "SELF_EXCLUDE";
    ResponsibleGamingMenuTabs["PLAY_CONTROL"] = "PLAY_CONTROL";
    ResponsibleGamingMenuTabs["PERIODIC_ACCOUNT_REVIEW"] = "PERIODIC_ACCOUNT_REVIEW";
})(exports.ResponsibleGamingMenuTabs || (exports.ResponsibleGamingMenuTabs = {}));
(function (ResponsibleGamingPage) {
    ResponsibleGamingPage["LIMITS"] = "limits";
    ResponsibleGamingPage["REALITY_CHECK"] = "reality-check";
    ResponsibleGamingPage["TIME_OUT"] = "time-out";
    ResponsibleGamingPage["SELF_EXCLUDE"] = "self-exclude";
    ResponsibleGamingPage["PLAY_CONTROL"] = "play-control";
    ResponsibleGamingPage["PERIODIC_ACCOUNT_REVIEW"] = "periodic-account-review";
})(exports.ResponsibleGamingPage || (exports.ResponsibleGamingPage = {}));
